<onyx-section [heading]="`${I18N}.heading`">
  <div class="container">
    <form [formGroup]="form()" [onyxAutoFocus]="mode()">
      <div class="wrapper">
        @let controls = form().controls;
        <onyx-dropdown
          [formControl]="controls.primaryDriverUuid"
          [label]="
            mode() === OnyxFormMode.ADD
              ? `${I18N}.primaryDriver`
              : 'labels.driver'
          "
          [link]="links().primaryDriver"
          [options]="DRIVERS_SOURCE"
          [optional]="true"
          (selectedOptionValueChange)="primaryDriver.set($event.value)"
          [size]="32"
        ></onyx-dropdown>

        @if (
          mode() === OnyxFormMode.ADD ||
          (mode() === OnyxFormMode.EDIT && controls.secondaryDriverUuid.value)
        ) {
          <onyx-form-group [controls]="controls.secondaryDriverUuid">
            <onyx-dropdown
              [formControl]="controls.secondaryDriverUuid"
              label="labels.secondaryDriver"
              [link]="links().secondaryDriver"
              [options]="DRIVERS_SOURCE"
              [optional]="true"
              [showErrors]="false"
              (selectedOptionValueChange)="secondaryDriver.set($event.value)"
              [size]="32"
            ></onyx-dropdown>

            <onyx-suggestions
              [control]="controls.secondaryDriverUuid"
              [suggestions]="secondaryDriverSuggestions()"
            ></onyx-suggestions>
          </onyx-form-group>
        }
      </div>

      <div class="wrapper">
        <onyx-form-group [controls]="controls.vehicleUuid">
          <onyx-dropdown
            [formControl]="controls.vehicleUuid"
            label="labels.vehicle"
            [link]="links().vehicle"
            [options]="VEHICLES_SOURCE"
            [optional]="true"
            [showErrors]="false"
            (selectedOptionValueChange)="vehicle.set($event.value)"
            [size]="32"
          ></onyx-dropdown>

          <onyx-suggestions
            [control]="controls.vehicleUuid"
            [suggestions]="vehicleSuggestions()"
          ></onyx-suggestions>
        </onyx-form-group>

        <onyx-form-group [controls]="controls.trailerUuid">
          <onyx-dropdown
            [formControl]="controls.trailerUuid"
            [label]="trailerLabel()"
            [link]="links().trailer"
            [options]="TRAILERS_SOURCE"
            [optional]="true"
            [showErrors]="false"
            (selectedOptionValueChange)="trailer.set($event.value)"
            [size]="32"
          ></onyx-dropdown>

          <onyx-suggestions
            [control]="controls.trailerUuid"
            [suggestions]="trailerSuggestions()"
          ></onyx-suggestions>
        </onyx-form-group>
      </div>
    </form>

    @if (planningCountriesMessage(); as message) {
      <onyx-message [intent]="message.intent" [showExpandButton]="true">
        <onyx-icon [name]="message.icon" [size]="16"></onyx-icon>

        <span
          [innerHTML]="`${I18N}.${message.message}` | translate: message"
        ></span>
      </onyx-message>
    }

    @if (isActive() && vehicle(); as vehicle) {
      <onyx-message intent="information">
        <onyx-icon name="tooltip-filled" [size]="20"></onyx-icon>

        <p>{{ `${I18N}.changesInActiveDelegation` | translate }}</p>

        <onyx-button variant="ghost" [size]="32" (click)="planChange(vehicle)">
          {{ 'labels.planChange' | translate }}
        </onyx-button>
      </onyx-message>
    }
  </div>
</onyx-section>
